import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { GraduationCap, PlayCircle, Eye } from "@phosphor-icons/react";

export const TRAINING_CHECK_KEY = "sdm_training_check";

export default function TrainingReminderModal() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pending, setPending] = useState([]);

  useEffect(() => {
    if (user?.role !== "bdc_agent" || user?.must_change_password || !sessionStorage.getItem(TRAINING_CHECK_KEY)) return;
    sessionStorage.removeItem(TRAINING_CHECK_KEY);
    api.get("/training/videos")
      .then((r) => setPending((r.data.videos || []).filter((v) => v.course === "agent" && !v.passed)))
      .catch(() => {});
  }, [user]);

  const close = () => setPending([]);
  return (
    <Dialog open={pending.length > 0} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md" data-testid="training-reminder-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <GraduationCap size={20} weight="fill" className="text-emerald-600" /> Tu entrenamiento está pendiente
          </DialogTitle>
          <DialogDescription>
            Para estar <b>Listo</b> te falta aprobar {pending.length} {pending.length === 1 ? "video" : "videos"}:
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-1.5" data-testid="training-reminder-list">
          {pending.map((v) => (
            <li key={v.id} className="flex items-center gap-2 text-sm" data-testid={`training-reminder-item-${v.id}`}>
              {v.watched_at ? <Eye size={15} className="text-amber-500 shrink-0" /> : <PlayCircle size={15} className="text-muted-foreground shrink-0" />}
              <span className="flex-1">{v.title}</span>
              <span className="text-[10px] text-muted-foreground">{v.watched_at ? "Falta cuestionario" : "Sin ver"}</span>
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={close} data-testid="training-reminder-later">Más tarde</Button>
          <Button onClick={() => { close(); navigate("/training"); }} data-testid="training-reminder-go">Ir a Entrenamiento</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
